import { isFunction, mapValues } from 'lodash';

import { t } from '../i18next';

type L10nConfigFn = (args: { [key: string]: string }) => string;
export interface L10nConfig {
  [key: string]: string | L10nConfig | L10nConfigFn;
}

/**
 * Maps the values of a configuration to use either t('') to translate it, or a function to manually translate it
 * @param {TConfig} l10nConfig
 */
export function mapL10nKeys<TConfig extends object>(l10nConfig: TConfig): TConfig {
  return mapValues(l10nConfig, (l10n: string | L10nConfig | L10nConfigFn) => {
    // If its an object, lets recursivly map the keys
    if (typeof l10n === 'object') {
      return mapL10nKeys(l10n);
    }
    if (isFunction(l10n)) {
      // If it's a function just return the function and let the consumer translate
      return l10n;
    }
    // translate the key
    return t(l10n);
  }) as TConfig;
}
